import _ from "lodash";
import { ToastStore } from "react-toasts";
import { setLoader, setSeleccionados } from "./devoluciones";
import { push } from "react-router-redux";
import { api } from "api";
import Swal from "sweetalert2";

const endpoint = "bodegas";

export const asignarBaja = (producto, baja) => (dispatch, getStore) => {
    const store = getStore();
    const { conf_inventario_negativo } = store.usuario;
    const seleccionados = _.cloneDeep(store.devoluciones.seleccionados);
    const item = _.find(seleccionados, { id: producto.id });
    const index = seleccionados.indexOf(item);
    if (item.total < parseInt(baja)) {
        if (conf_inventario_negativo) {
            item.baja = baja;
        } else {
            Swal(
                "ERROR",
                "No puede registrar una baja mayor al número de existencias actual de un producto",
                "error"
            );
            item.baja = item.total;
        }
    } else if (baja < 0) {
        item.baja = 0;
    } else {
        item.baja = baja;
    }
    seleccionados.splice(index, 1, item);
    dispatch(setSeleccionados(seleccionados));
};

export const efectuarBaja = () => (dispatch, getStore) => {
    const store = getStore();
    const seleccionados = store.devoluciones.seleccionados;
    const data = store.form.BajasProducto.values;

    const tipo_compra = 1;

    const endpoint_devolucion =
        tipo_compra == 1 ? "devoluciones" : "devoluciones_venta";

    const sucursal = store.usuario.sucursal;
    data.sucursal = sucursal;
    dispatch(setLoader(true));
    // api.post(`${endpoint}/baja`, {
    api.post(`${endpoint}/${endpoint_devolucion}`, {
        productos: seleccionados,
        motivo: data.motivo,
    })
        .then((resp) => {
            if (resp) {
                ToastStore.success("Datos almacenados correctamente");
                dispatch(push(`/bodega/resumen_de_ingreso/${resp.id}`));
            }
        })
        .catch((err) => {
            if (err) {
                if (err.detail) {
                    Swal("ERROR", err.detail, "error");
                } else {
                    Swal(
                        "ERROR",
                        "Ha ocurrido un error, verifique los datos y vuelva a intentar.",
                        "error"
                    );
                }
            } else {
                Swal(
                    "ERROR",
                    "Ha ocurrido un error, verifique los datos y vuelva a intentar.",
                    "error"
                );
            }
        })
        .finally(() => {
            dispatch(setLoader(false));
            dispatch(setSeleccionados([]));
        });
};

export const actions = {
    asignarBaja,
    efectuarBaja,
};
